import {Component, Input, OnInit} from '@angular/core';
import {ViewCell} from 'ng2-smart-table';
import {ApiService} from '../../../../@core/service/api.service';

@Component({
  selector: 'ngx-form-list-business-unit-renderer',
  template: '{{renderValue}}',
})
export class FormListBusinessUnitRendererComponent implements ViewCell, OnInit {
  renderValue: string;

  @Input() value: any;
  @Input() rowData: any;

  constructor(private api: ApiService) {

  }


  ngOnInit() {
    // console.log(this.value);
    /* if (this.value != null)
      this.renderValue = JSON.parse(this.value).name;*/
    const prj = this.api.getBusinessUnit(this.value);
    if (prj != null)
      this.renderValue = prj.name;
    else
      this.renderValue = 'error';
  }

}
